import React from 'react';
import { useSelector } from 'react-redux';
import { RootStore } from '../../store/reducers';
import { headerSelector } from '../../store/selectors/globalConfigSelectors';
import styles from './BoxLogo.module.scss';
import { isBolognaEnv } from '../../utils/common';
import { BOLOGNA_LOGO_URL } from '../../constants/common';
import Logo, { LOGO_THEME } from '../Logo/Logo';

const BoxLogo = () => {
  const isBologna = isBolognaEnv();
  const { header } = useSelector((state: RootStore) => ({
    header: headerSelector(state),
  }));

  const logo = () =>
    isBolognaEnv() ? (
      <img className="box-logo-img" src={BOLOGNA_LOGO_URL} />
    ) : (
      <Logo theme={LOGO_THEME.GREY} className="box-logo-img" />
    );

  return (
    <div className={styles.imgWrapper}>
      {header?.logoUrl ? (
        <img
          src={isBologna ? BOLOGNA_LOGO_URL : header?.logoUrl}
          alt=""
          className={styles.logo}
        />
      ) : (
        logo()
      )}
    </div>
  );
};

export default BoxLogo;
